import type {IAudienceDto} from "./audience.dto";
import EntityModel from "../../entity/_model/EntityModel";
import {EntityType} from "../../entity/_model/entity.constants";

export default class AudienceModel extends EntityModel implements IAudienceDto {
    public entityType: EntityType = EntityType.AUDIENCE;

    public ID = "";
    public apps: any = {};
    public email = "";
    public langCode = "";
    public lastName = "";
    public firstName = "";
    public companyName = "";
    public displayName = "";
    public avatarFileUri = "assetFolder://asf-0/audience_avatar_default.png";
    public referenceCode = "";
    public data: any = {};

    public hasAppData(resourceIdentifier: string): boolean {
        return !!this.apps[resourceIdentifier];
    }

    public getAppData(resourceIdentifier: string): any {
        return this.apps[resourceIdentifier];
    }

    public hasCustomDataProperty(...keys: string[]): boolean {
        return this.getCustomDataProperty(...keys) !== null && this.getCustomDataProperty(...keys) !== undefined;
    }

    public getCustomDataProperty(...keys: string[]): any {
        return this.data && keys.reduce(
            (result, prop) => result == null ? undefined : result[prop],
            this.data
        );
    }
}
